module.exports = __webpack_public_path__ + "static/media/app-header-logo.acb68728.png";